import React, { useContext } from 'react';
import { Grid } from 'components/layout/Grid';
import { Brikk } from 'components/Brikk';
import { MultiTabContext } from 'components/menus/MultiTabMenu';
import { Tabs } from 'components/menus/MultiTabMenu/Tabs';
import { LaundryBrikkModalContext } from '../../../LaundryBrikkModalContext';
import { BookingHistoryFiltersAndExport } from '../BookingHistoryFiltersAndExport';
import { DateSelectionSection } from '../DateSelectionSection';

const TAB_BOOK_RESOURCE = 'bookAResource';
const TAB_BOOKING_HISTORY = 'bookingHistory';

const tabs = {
  [TAB_BOOK_RESOURCE]: {
    title: TAB_BOOK_RESOURCE,
  },
  [TAB_BOOKING_HISTORY]: {
    title: TAB_BOOKING_HISTORY,
  },
};

export function BookResourceAndBookingExportSection({ laundryResources }) {
  const { activeTab, setActiveTab } = useContext(LaundryBrikkModalContext);

  return (
    <Grid.Column>
      <Brikk.Heading heading="laundryBrikk">
        <MultiTabContext.Provider value={{ activeTab, setActiveTab }}>
          <Tabs
            tabs={tabs}
            showOr={false}
          />
        </MultiTabContext.Provider>
      </Brikk.Heading>

      <div hidden={activeTab !== TAB_BOOK_RESOURCE}>
        <DateSelectionSection laundryResources={laundryResources} />
      </div>

      <div hidden={activeTab !== TAB_BOOKING_HISTORY}>
        <BookingHistoryFiltersAndExport />
      </div>
    </Grid.Column>
  );
}
